import { useIsMutating } from '@tanstack/react-query'
import { useEffect } from 'react'

export const NavigationBlocker = () => {
  const isMutating = useIsMutating() > 0

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      event.returnValue = 'navigation blocked'
    }

    if (isMutating) {
      window.addEventListener('beforeunload', handleBeforeUnload)
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [isMutating])

  return null
}
